module.exports = __webpack_public_path__ + "static/media/logo2022-2.76d0b5ed.png";